// extracted by mini-css-extract-plugin
module.exports = {"buttonLink":"links-module--button-link--1NSaT","primary":"links-module--primary--2QxQi","secondary":"links-module--secondary--X9cXJ","anchor":"links-module--anchor--11-Pb"};